import React, { useState } from 'react';
import { useSelector } from 'react-redux'
import classNames from 'classnames';
import { makeStyles } from '@mui/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import IconMaterials from '@mui/icons-material/ListAlt'
import { ListItem, ListItemIcon, ListItemText, Drawer, List, ListItemButton } from '@mui/material';
import SelectedProject from '../listLinlDraver/SelectedProject'
import { API_BO } from '../../conf'
import { Link } from 'react-router-dom';
import ListProjectSelect from './ListProjectSelect'
import { butt } from './ListButton'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/styles';

const drawerWidth = 240;
const useStyleDriver = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7),
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justify: 'flex-start',
    padding: '0 8px',
    // marginLeft: 'auto',
    marginRight: 'auto',
    marginLeft: '33px',
    ...theme.mixins.toolbar,
  },
}))
const ListItemTextBold = (props) => <ListItemText primaryTypographyProps={{ style: { fontWeight: 'bold' } }} {...props} />
export default function LeftDrawer({ handleDrawerClose, open }) {
  const theme = useTheme();
  const isPermanent = useMediaQuery(theme.breakpoints.up('sm'));
  const classes = useStyleDriver()
  const [selectedDriver, setSelected] = useState('')
  const facilityId = useSelector(state => state.header?.facilityId)
  const objectDisabled = typeof facilityId === 'undefined' || facilityId === 0
  return <Drawer
    variant={isPermanent ? 'permanent' : 'temporary'}
    className={classNames(classes.drawer, {
      [classes.drawerOpen]: open,
      [classes.drawerClose]: !open,
    })}
    classes={{
      paper: classNames({
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      }),
    }}
    open={open}
  >
    <div className={classes.toolbar}>
      <img src='/logo.svg' alt='logo' width='80%' height={'120%'} />
    </div>
    <hr className='App-divider' />
    <List component="nav">
      {!isPermanent && <React.Fragment>
        <ListItemButtonBold text='Главное' onClick={handleDrawerClose} open={open} />
        <ListItem><ListItemTextBold dense primary={localStorage.getItem('accountName') || ''} /></ListItem>
        <ListItemLink text='Аккаунты' to='/accounts' />
        {butt.map(e => <ListItemLink key={e.primary} text={e.primary} to={e.link} />)}
        <ListItem><ListItemTextBold dense inset primary={"Объект"} /></ListItem>
      </React.Fragment>}
      {isPermanent && <ListItemButtonBold text='Объект' onClick={handleDrawerClose} open={open} />}
      <ListItemLink text='Главное' to={`/facility/our/${facilityId}`} Icon={<AccountBalanceIcon />} disabled={objectDisabled} />
      <ListItemLink text='Меню' to={`/facility/our/${facilityId}/menu`} Icon={<IconMaterials />} disabled={objectDisabled} />
      <hr className='App-divider' />
      {open && <ListProjectSelect facilityId={facilityId} />}
    </List>
    <hr className='App-divider' />
    <SelectedProject open={open} selectedDriver={selectedDriver} setSelected={name => setSelected(name)} />
    <hr className='App-divider' />
    <ListItemButtonBold text='Скрыть панель' onClick={handleDrawerClose} open={open} />
  </Drawer>
}

function ListItemLink({ to, disabled = false, Icon = null, text }) {
  const itemLink = React.forwardRef((props, ref) => (<Link ref={ref} to={API_BO + to} {...props} />))
  return <ListItemButton component={itemLink} disabled={disabled} dense>
    {Icon && <ListItemIcon>{Icon}</ListItemIcon>}
    <ListItemText primary={text} />
  </ListItemButton >
}

function ListItemButtonBold({ onClick, text, open }) {
  return <ListItemButton onClick={onClick} dense>
    <ListItemIcon> {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}</ListItemIcon>
    <ListItemTextBold primary={text} />
  </ListItemButton>
}